<template>
    <v-app>
        <!-- Indicator flotant impersonare -->
        <div v-if="impersonatedBy" class="imp-pill">
            <span class="imp-pill-ico"><v-icon size="18" color="white">mdi-account-switch</v-icon></span>
            <span class="imp-pill-txt">
                <span class="imp-pill-lbl">Impersonare</span>
                <span class="imp-pill-user">{{ currentUsername }}</span>
            </span>
            <button class="imp-pill-exit" title="Ieși din impersonare" @click="exitImpersonation">
                <v-icon size="16">mdi-logout</v-icon> Ieși
            </button>
        </div>

        <!-- Dialog „Raportează o problemă" (declanșat din navbar) -->
        <BugReportWidget ref="bugReport" />

        <!-- Professional Top Bar -->
        <v-app-bar :color="APP_Color" elevation="0" height="56" class="premium-topbar">
            <v-app-bar-nav-icon @click="drawer = !drawer" color="white" class="menu-btn" />

            <router-link :to="{ path: '/' }" class="app-branding" @click="goHome">
                <span class="brand-mark">
                    <span class="brand-text">ERA</span>
                    <span class="brand-badge">ERP</span>
                </span>
                <span class="brand-powered">Powered by <strong>Else Digital Solutions</strong></span>
            </router-link>

            <v-spacer />

            <!-- Notificări (clopoțel global) -->
            <NotificariBell />

            <!-- Raportează o problemă -->
            <v-btn icon variant="text" color="white" class="report-btn"
                   title="Raportează o problemă" @click="openBugReport">
                <v-icon>mdi-bug-outline</v-icon>
            </v-btn>

            <!-- Company Selector -->
            <v-menu offset-y :close-on-content-click="false">
                <template #activator="{ props }">
                    <button v-bind="props" class="company-selector">
                        <span class="cs-avatar">{{ companyInitials(currentCompanyName) }}</span>
                        <span class="cs-info">
                            <span class="cs-eyebrow">Companie</span>
                            <span class="cs-name">{{ currentCompanyName }}</span>
                        </span>
                        <v-icon size="18" class="cs-chevron">mdi-chevron-down</v-icon>
                    </button>
                </template>

                <v-card class="company-dropdown" elevation="12">
                    <div class="cd-head">
                        <span class="cd-title">Companii</span>
                        <span class="cd-count">{{ companies.length }}</span>
                    </div>

                    <div v-if="companies.length > 6" class="company-search">
                        <v-icon size="16" class="cs-search-ico">mdi-magnify</v-icon>
                        <input v-model="companySearch" type="text" placeholder="Caută companie..." />
                    </div>

                    <div class="company-list">
                        <button v-for="c in filteredCompanies" :key="c.ID" @click="switchCompany(c)"
                            class="company-list-item" :class="{ active: c.ID === currentCompanyId }">
                            <span class="company-avatar" :class="{ ring: c.ID === currentCompanyId }">
                                {{ companyInitials(c.Name) }}
                            </span>
                            <span class="company-name">{{ c.Name }}</span>
                            <v-icon v-if="c.ID === currentCompanyId" size="18" class="company-check">mdi-check-circle</v-icon>
                        </button>
                        <div v-if="!filteredCompanies.length" class="company-empty">Nicio companie găsită.</div>
                    </div>
                </v-card>
            </v-menu>

            <!-- User Section -->
            <v-menu offset-y :close-on-content-click="true">
                <template #activator="{ props }">
                    <button v-bind="props" class="user-section">
                        <span class="us-avatar">{{ userInitials }}</span>
                        <span class="user-name">{{ Username }}</span>
                        <v-icon size="18" class="us-chevron">mdi-chevron-down</v-icon>
                    </button>
                </template>

                <v-card class="user-menu" elevation="12">
                    <div class="um-head">
                        <span class="um-avatar">{{ userInitials }}</span>
                        <div class="um-info">
                            <span class="um-name">{{ Username }}</span>
                            <span class="um-role">{{ isSuperAdminUser ? 'Super Administrator' : 'Utilizator' }}</span>
                        </div>
                    </div>

                    <div class="um-list">
                        <button v-if="isSuperAdminUser" class="um-item" @click="goSuperAdmin">
                            <v-icon size="18" class="um-ico">mdi-shield-crown</v-icon>
                            <span>Mod SuperAdmin</span>
                            <v-icon size="16" class="um-arrow">mdi-arrow-right</v-icon>
                        </button>
                        <button class="um-item danger" @click="Logout">
                            <v-icon size="18" class="um-ico">mdi-power-standby</v-icon>
                            <span>Deconectare</span>
                        </button>
                    </div>
                </v-card>
            </v-menu>

            <!-- Version -->
            <v-chip :color="APP_Color" variant="text" size="small" class="version-badge"
                @click="showAllChangelog = true">
                <v-icon size="12" class="mr-1">mdi-information</v-icon>
                v{{ APP_Version }}
            </v-chip>
        </v-app-bar>

        <!-- Ultra Premium Navigation Drawer -->
        <v-navigation-drawer app v-model="drawer" :color="APP_Color" theme="dark" :elevation="0" permanent
            width="300" class="premium-drawer">


            <!-- Menu List -->
            <v-list v-model:opened="open" class="drawer-menu-list">
                <template v-for="row in Menu.filter(x => x.Level == 1)" :key="row.ID">
                    <v-list-group v-if="Menu.some(x => x.MenuID == row.ID)" :prepend-icon="row.Icon"
                        class="menu-group-item">
                        <template v-slot:activator="{ props }">
                            <v-list-item v-bind="props" :title="row.Title" class="menu-parent-item" />
                        </template>

                        <!-- LEVEL 2 -->
                        <template v-for="row2 in Menu.filter(x => x.MenuID == row.ID)" :key="row2.ID">
                            <v-list-group v-if="Menu.some(x => x.MenuID == row2.ID)" no-action
                                class="menu-subgroup-item">
                                <template v-slot:activator="{ props }">
                                    <v-list-item v-bind="props" :title="row2.Title" class="menu-child-item" />
                                </template>

                                <!-- LEVEL 3 -->
                                <v-list-item v-for="row3 in Menu.filter(x => x.MenuID == row2.ID)" :key="row3.ID"
                                    :title="row3.Title" @click="ShowPage(row3.Title, row3.Url)"
                                    class="menu-grandchild-item" />
                            </v-list-group>

                            <!-- Level 2 fără copii -->
                            <v-list-item v-else :title="row2.Title" @click="ShowPage(row2.Title, row2.Url)"
                                class="menu-child-item" />
                        </template>
                    </v-list-group>

                    <!-- Level 1 fără copii -->
                    <v-list-item v-else :title="row.Title" :prepend-icon="row.Icon"
                        @click="ShowPage(row.Title, row.Url)" class="menu-single-item" />
                </template>
            </v-list>

            <!-- Drawer Footer -->
            <template v-slot:append>
                <div class="drawer-footer-section">
                    <v-divider class="footer-divider" />
                    <v-list-item prepend-icon="mdi-power-standby" title="Deconectare" @click="Logout"
                        class="logout-item">
                        <template #append>
                            <v-icon size="18">mdi-exit-to-app</v-icon>
                        </template>
                    </v-list-item>
                </div>
            </template>
        </v-navigation-drawer>
        <!-- Main Content Area -->
        <v-main class="main-content-area">
            <v-container fluid class="content-container">
                <v-card class="content-card" elevation="8">
                    <!-- Fixed Card Header -->
                    <div v-if="!$route.path.startsWith('/documente') && !$route.path.startsWith('/comenzi') && !$route.path.startsWith('/medical') && !$route.path.startsWith('/produse') && !$route.path.startsWith('/clase') && !$route.path.startsWith('/stocuri')" class="card-header-fixed">
                        <!-- <v-card-title class="card-title-section">
                            <v-icon :color="APP_Color" size="24" class="mr-3">mdi-file-document-outline</v-icon>
                            <span>{{ TabTitle || 'Panou Principal' }}</span>
                        </v-card-title> -->

                        <!-- Breadcrumbs -->
                        <div v-if="breadcrumb.length" class="breadcrumb-section">
                            <VBreadcrumbs :items="breadcrumb" class="breadcrumb-custom">
                                <template v-slot:divider>
                                    <v-icon size="14" color="grey">mdi-chevron-right</v-icon>
                                </template>
                                <template v-slot:item="{ item }">
                                    <VBreadcrumbsItem :link="!!item.url"
                                        :style="item.url ? 'cursor: pointer' : ''"
                                        @click="item.url && ShowPage(item.title, item.url)">
                                        {{ item.title }}
                                    </VBreadcrumbsItem>
                                </template>
                            </VBreadcrumbs>
                        </div>

                        <v-divider :color="APP_Color" class="header-divider" />
                    </div>

                    <!-- Scrollable Content -->
                    <div :class="['card-content-scrollable', { 'full-screen-content': isFullScreenRoute }]">
                        <router-view :class="['router-content', { 'router-content-full': isFullScreenRoute }]" />
                    </div>
                </v-card>
            </v-container>
        </v-main>

        <v-footer app>
            <!-- -->
        </v-footer>

        <!-- Dialog ultimele update-uri -->
        <v-dialog v-model="showChangelog" max-width="520px" persistent>
            <v-card class="changelog-card">
                <div class="changelog-header">
                    <v-icon color="white" size="20" class="mr-2">mdi-new-box</v-icon>
                    <span>Ce e nou în versiunea {{ APP_Version }}</span>
                </div>

                <v-card-text class="whatsnew-body">
                    <div v-if="hasDesc(latestUpdate[0]?.description)" class="wn-desc">
                        {{ latestUpdate[0].description }}
                    </div>

                    <div v-if="groupModules(latestUpdate[0]?.modules || []).length" class="wn-list">
                        <div v-for="(g, i) in groupModules(latestUpdate[0].modules)" :key="i" class="wn-group">
                            <div class="wn-ghead">
                                <span class="dotm"></span>{{ g.module }}
                                <span v-if="g.items.length > 1" class="cnt">{{ g.items.length }}</span>
                            </div>
                            <ul v-if="g.items.length" class="wn-bullets">
                                <li v-for="(t, j) in g.items" :key="j">{{ t }}</li>
                            </ul>
                        </div>
                    </div>

                    <div v-else-if="!hasDesc(latestUpdate[0]?.description)" class="wn-empty">
                        Îmbunătățiri și corecții interne.
                    </div>
                </v-card-text>

                <v-card-actions class="justify-end">
                    <v-btn color="primary" variant="text" @click="markAsSeen">Am înțeles</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>





        <!-- Dialog istoricul complet -->
        <v-dialog v-model="showAllChangelog" max-width="660px" scrollable>
            <v-card class="changelog-card">
                <div class="changelog-header">
                    <v-icon color="white" size="20" class="mr-2">mdi-history</v-icon>
                    <span>Istoricul versiunilor</span>
                    <v-spacer />
                    <v-btn icon variant="text" density="comfortable" @click="showAllChangelog = false">
                        <v-icon color="white" size="20">mdi-close</v-icon>
                    </v-btn>
                </div>
                <v-card-text class="changelog-body">
                    <div v-for="grp in changelogGrouped" :key="grp.day" class="cl-day-group">
                        <div class="cl-day-label">{{ grp.day }}</div>
                        <div class="cl-timeline">
                            <div v-for="entry in grp.entries" :key="entry.version" class="cl-entry">
                                <span class="cl-dot" :class="{ 'is-new': entry.isNew }"></span>
                                <div class="cl-content">
                                    <div class="cl-entry-head">
                                        <span class="cl-version">v{{ entry.version }}</span>
                                        <span v-if="entry.isNew" class="cl-new-badge">NOU</span>
                                        <span class="cl-time">{{ formatTime(entry.date) }}</span>
                                    </div>
                                    <div v-if="hasDesc(entry.description)" class="cl-desc">{{ entry.description }}</div>
                                    <div v-if="groupModules(entry.modules || []).length" class="cl-grouped">
                                        <div v-for="(g, i) in groupModules(entry.modules)" :key="i" class="clg">
                                            <span class="clg-mod">{{ g.module }}</span>
                                            <ul v-if="g.items.length">
                                                <li v-for="(t, j) in g.items" :key="j">{{ t }}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="!changelogGrouped.length" class="cl-empty">Nu există versiuni înregistrate.</div>
                </v-card-text>
            </v-card>
        </v-dialog>


    </v-app>
</template>

<script lang="ts">

import { defineComponent } from 'vue';
import { useChangelog } from '@/composable/useChangelog';
import AppSettings from '@/settings/appSettings'
import JwtServices from '@/services/JwtServices';
import { clearGridComenziColumnFilters } from '@/utility/gridComenziState';
import PreturiFurnizor from './Comercial/PreturiFurnizor.vue'
import Documente from './Documente/Documente.vue';
import RaportCashFlowView from './Rapoarte/RaportCashFlowView.vue';
import Oportunitati from './Comercial/CRM/Oportunitati.vue'
import AdminView from './ADMIN/Admin.vue'
import Nomenclatoare from './ADMIN/Nomenclatoare.vue'
import Calendar from './Calendar/Calendar.vue';
import GridContacte from './Comercial/CRM/GridContacte.vue';
import GridOportunitati from './Comercial/CRM/GridOportunitati.vue';
import GridTabActivitati from './Comercial/CRM/GridTabActivitati.vue';
import GridRoluri from './AUTH/GridRoluri.vue';
import GridRoluriUtilizatori from './AUTH/GridRoluriUtilizatori.vue';
import GridDrepturiCustom from './AUTH/GridDrepturiCustom.vue';
import GridDrepturiUtilizatori from './AUTH/GridDrepturiUtilizatori.vue';
import GridDrepturiRoluri from './AUTH/GridDrepturiRoluri.vue';
import GridBilanturi from './Contabilitate/GridBilanturi.vue';
import GridFormuleRanduri from './Contabilitate/GridFormuleRanduri.vue';
import GridTabMeniuBilanturi from './Contabilitate/GridTabMeniuBilanturi.vue';
import CompanyServices from "@/services/CompanyService";
import drepturi from "@/settings/drepturi";
import GridDrepturiCustomsiMeniu from './AUTH/GridDrepturiCustomsiMeniu.vue';
import GridUtilizatorisiDrepturi from './AUTH/GridUtilizatorisiDrepturi.vue';
import GridRolurisiDrepturi from './AUTH/GridRolurisiDrepturi.vue';
import GridUtilizatori from './AUTH/GridUtilizatori.vue';
import { VBreadcrumbs, VBreadcrumbsItem } from 'vuetify/components'
import CompanyService from '@/services/CompanyService';
import notify from 'devextreme/ui/notify';
import BugReportWidget from '@/components/BugReportWidget.vue';
import NotificariBell from '@/components/NotificariBell.vue';

// Normalizare pentru comparat nume de module (lowercase, fără diacritice).
function normalizeModuleToken(s: string): string {
    return (s || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .trim();
}

// Note generale de aplicație (nu sunt module controlate prin drepturi) — apar
// la toți utilizatorii. Restul numelor care nu corespund unui modul din DB se ascund.
const CHANGELOG_GLOBAL_MODULES = new Set(['aplicatie', 'autentificare']);

export default defineComponent({
    name: 'HomeView',

    components: {
        VBreadcrumbs,
        VBreadcrumbsItem,
        AppSettings,
        BugReportWidget,
        NotificariBell,
        PreturiFurnizor,
        Documente,
        RaportCashFlowView,
        Oportunitati,
        AdminView,
        Nomenclatoare,
        Calendar,
        GridContacte,
        GridOportunitati,
        GridTabActivitati,
        GridRoluri,
        GridRoluriUtilizatori,
        GridDrepturiCustom,
        GridDrepturiUtilizatori,
        GridDrepturiRoluri,
        GridBilanturi,
        GridFormuleRanduri,
        GridTabMeniuBilanturi,
        GridDrepturiCustomsiMeniu,
        GridUtilizatorisiDrepturi,
        GridRolurisiDrepturi,
        GridUtilizatori
    },

    data() {
        return {
            showChangelog: false,
            showAllChangelog: false,
            newUpdates: [] as Array<any>,
            changelog: [] as Array<any>,
            moduleCatalog: [] as string[],
            moduleAccessible: [] as string[],
            breadcrumb: [] as any[],
            drawer: false,
            openMenu: null,
            open: ['Documente'],
            APP_Color: AppSettings.APP_Color,
            APP_Version: AppSettings.APP_Version,
            Username: " ",
            currentView: "",
            TabTitle: '',
            Menu: [],
            companies: [] as Array<{ ID: string; Name: string }>,
            currentCompanyId: '' as string,
            companySearch: '' as string
        }
    },
    methods: {
        exitImpersonation() {
            try {
                const raw = localStorage.getItem("ERA_ImpersonateBackup");
                if (raw) {
                    const b = JSON.parse(raw);
                    if (b.jwt) localStorage.setItem("ERA_Jwt", b.jwt);
                    if (b.company) localStorage.setItem("ERA_Company", b.company);
                    else localStorage.removeItem("ERA_Company");
                    if (b.superChoice != null) localStorage.setItem("ERA_SuperAdminChoice", b.superChoice);
                }
            } catch { /* ignore */ }
            localStorage.removeItem("ERA_ImpersonateBackup");
            window.location.assign("/SuperAdmin");
        },
        acknowledgeUpdates() {
            this.markAsSeen();        // marchează versiunea ca văzută
            this.showChangelog = false; // închide dialogul
        },
        formatDate(iso: string) {
            const d = new Date(iso);
            return d.toLocaleDateString() + " " + d.toLocaleTimeString();
        },
        formatTime(iso: string) {
            const d = new Date(iso);
            return isNaN(d.getTime()) ? '' : d.toLocaleTimeString('ro-RO', { hour: '2-digit', minute: '2-digit' });
        },
        openBugReport() {
            (this.$refs.bugReport as any)?.open();
        },
        hasDesc(desc: string) {
            const d = (desc || '').trim();
            return d !== '' && d !== '—' && d !== '...' && d !== '....';
        },
        modName(m: any) {
            if (!m) return '';
            return typeof m === 'string' ? m : (m.module || m.Module || '');
        },
        modDesc(m: any) {
            if (!m || typeof m === 'string') return '';
            return m.description || m.Description || '';
        },
        companyInitials(name: string) {
            const n = (name || '').trim();
            if (!n || n === '—') return '—';
            const parts = n.split(/\s+/).filter(Boolean);
            const a = parts[0]?.[0] || '';
            const b = parts.length > 1 ? parts[parts.length - 1][0] : (parts[0]?.[1] || '');
            return (a + b).toUpperCase();
        },
        companyAvatarStyle(name: string) {
            let h = 0;
            const n = name || '';
            for (let i = 0; i < n.length; i++) h = (h * 31 + n.charCodeAt(i)) % 360;
            return {
                background: `hsl(${h}, 55%, 94%)`,
                color: `hsl(${h}, 45%, 42%)`,
            };
        },
        isModuleVisible(name: string): boolean {
            // SuperAdmin vede tot.
            if (this.isSuperAdminUser) return true;
            const n = normalizeModuleToken(name);
            if (!n) return false;
            // Note generale de aplicatie => vizibile tuturor.
            if (CHANGELOG_GLOBAL_MODULES.has(n)) return true;
            // Modul controlat prin drepturi => vizibil doar daca userul are acces.
            if (this.moduleCatalogSet.has(n)) return this.moduleAccessibleSet.has(n);
            // Orice alt nume (nu e modul in DB, nu e nota generala) => ascuns.
            return false;
        },
        groupModules(modules: any[]) {
            const out: Array<{ module: string; items: string[] }> = [];
            const idx: Record<string, number> = {};
            (modules || []).forEach((m: any) => {
                const name = this.modName(m);
                const desc = this.modDesc(m);
                if (!name) return;
                if (!this.isModuleVisible(name)) return;
                if (idx[name] === undefined) { idx[name] = out.length; out.push({ module: name, items: [] }); }
                if (desc) out[idx[name]].items.push(desc);
            });
            return out;
        },
        GetUser() {
            const rawUsername = JwtServices.GetUsername() || '';
            this.Username = rawUsername
                .split(/[.\s_-]+/)
                .map((w: string) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
                .join(' ');
        },
        ShowPage(Title: string, Url: string) {
            this.$router.push({ name: Url });
            this.TabTitle = Title;
            this.breadcrumb = this.getBreadcrumb(Url).map(x => ({ title: x.Title, url: x.Url }));
            this.drawer = false;
        },
        Logout() {
            localStorage.removeItem("ERA_Jwt");
            localStorage.removeItem("ERA_Company");
            clearGridComenziColumnFilters();
            this.$router.go(0);
        },
        goSuperAdmin() {
            localStorage.setItem("ERA_SuperAdminChoice", "true");
            this.$router.go(0);
        },
        getBreadcrumb(url: string) {
            const crumbs: any[] = [];
            let current = this.Menu.find((x: any) => x.Url === url);
            while (current) {
                crumbs.unshift(current);
                current = this.Menu.find((x: any) => x.ID == current.MenuID);
            }
            return crumbs;
        },
        loadCompaniesFromStorage() {
            try {
                const raw = localStorage.getItem('ERA_Companies');
                this.companies = raw ? JSON.parse(raw) : [];
            } catch { this.companies = []; }

            try {
                const current = localStorage.getItem('ERA_Company');
                const obj = current ? JSON.parse(current) : null;
                this.currentCompanyId = obj?.ID || '';
            } catch { this.currentCompanyId = ''; }
        },

        async switchCompany(c: { ID: string; Name: string }) {
            notify('Modificarea companiei poate dura câteva momente', 'success', 3000);
            if (c.ID === this.currentCompanyId) return;

            try {
                const resp = await CompanyServices.switchCompany({ companyID: c.ID });
                const { token, company } = resp.data as { token: string; company: { ID: string; Name: string } };

                localStorage.setItem('ERA_Jwt', token);
                localStorage.setItem('ERA_Company', JSON.stringify(company));

                this.currentCompanyId = company.ID;


                await this.reloadMenusAfterSwitch();


                this.$router.go(0);
            } catch (e: any) {

                console.error(e);
            }
        },

        async reloadMenusAfterSwitch() {

            const response1 = await CompanyServices.getMenus();
            this.Menu = [];
            response1.data.forEach((x: any) => this.Menu.push(JSON.parse(x.MeniuConfig)));
            this.loadModuleAccess();
        },
        loadModuleAccess() {
            CompanyServices.getModuleAccess()
                .then((r: any) => {
                    this.moduleCatalog = r.data?.Catalog || [];
                    this.moduleAccessible = r.data?.Accessible || [];
                })
                .catch((e: any) => console.error('Nu pot încărca accesul pe module:', e));
        },
        goHome() {
            this.TabTitle = '';
            this.breadcrumb = [];
            this.dynamicParents = {};
        },
        onHomeBreadcrumb(e: any) {
            // Setat de HomeDashboard când afișează un dashboard pe pagina de start (ruta 'main').
            if (this.$route.name !== 'main') return;
            const label = e?.detail as string;
            this.breadcrumb = label ? [{ title: 'Acasă', url: '/' }, { title: label }] : [];
            this.TabTitle = label || '';
        },
        updateBreadcrumbs(route: any, from: any = null) {
            const routeName = route.name as string;
            if (!routeName) return;

            if (routeName === 'main') {
                this.breadcrumb = [];
                this.TabTitle = '';
                return;
            }

            // Initialize dynamicParents if needed
            if (!this.dynamicParents) this.dynamicParents = {};

            const customParents: Record<string, string> = {
                'GridContacte': 'CRMDashboard',
                'GridContactDetalii': 'GridContacte',
                'GridOportunitati': 'CRMDashboard',
                'GridTabActivitati': 'CRMDashboard',
                'Calendar': 'CRMDashboard',
                'GridParteneri': 'CRMDashboard',
                'GridCampanii': 'CRMDashboard',
                'CalendarActivitati': 'CRMDashboard',
                'RaportVanzariAgenti': 'CRMDashboard',
                'GridParametriAplicatie': 'AdminView',
                // Portal HR
                'PortalCereriConcediu': 'PortalDashboard',
                'PortalTichete': 'PortalDashboard',
                'PortalPontaj': 'PortalDashboard',
                'PortalPlanificareAnuala': 'PortalDashboard',
                'PortalAprobari': 'PortalDashboard',
                'PortalTicheteHR': 'PortalDashboard',
                'PortalRaportConcedii': 'PortalDashboard',
                'PortalRaportOreSuplimentare': 'PortalDashboard',
                'PortalProfil': 'PortalDashboard',
                // Medical
                'RecoltariProbeAnalize': 'LaboratorAnalize',
                // Producție
                'Autoreceptie': 'Documente',
                // Stocuri
                'InchiderePerioada': 'home',
                'AdminGestiuni': 'home',
            };

            const customTitles: Record<string, string> = {
                'GridContactDetalii': 'Detalii Contact'
            };

            // Dynamic Parent Logic
            if (from && from.name && from.name !== routeName) {
                // Logic for GridContacte
                if (routeName === 'GridContacte') {
                    if (from.name === 'GridParteneri') {
                        this.dynamicParents[routeName] = from.name;
                    } else {
                        // Reset to default
                        delete this.dynamicParents[routeName];
                    }
                }
                // Logic for GridOportunitati
                else if (routeName === 'GridOportunitati') {
                    if (from.name === 'GridContacte') {
                        this.dynamicParents[routeName] = from.name;
                    }
                    else if (from.name === 'GridContactDetalii') {
                        this.dynamicParents[routeName] = from.name;
                    }
                    else {
                        delete this.dynamicParents[routeName];
                    }
                }
                // Logic for GridTabActivitati
                else if (routeName === 'GridTabActivitati') {
                    if (from.name === 'GridContacte') {
                        this.dynamicParents[routeName] = from.name;
                    } else {
                        delete this.dynamicParents[routeName];
                    }
                }
                // Special Case: Jump from Parteneri to Contact Details
                else if (routeName === 'GridContactDetalii') {
                    if (from.name === 'GridParteneri') {
                        // We want: Parteneri -> Contacte -> Detalii
                        // So we set GridContacte's parent to Parteneri
                        this.dynamicParents['GridContacte'] = from.name;

                        // Ensure Detalii points to Contacte (should be default in customParents, but just in case)
                        delete this.dynamicParents[routeName];
                    }
                    else if (from.name !== 'GridContacte') {
                        // If we didn't come from Contacte (e.g. from Dashboard or link),
                        // ensure GridContacte is reset to default (Dashboard)
                        delete this.dynamicParents['GridContacte'];
                        // And ensure Detalii uses default parent logic
                        delete this.dynamicParents[routeName];
                    }
                }
                // Generic logic for other Detail pages
                else if (routeName.includes('Detalii') && routeName !== 'GridContactDetalii') {
                    const isFromMenu = this.Menu.some((x: any) => x.Url === from.name);
                    if (isFromMenu || customParents[from.name] || this.dynamicParents[from.name]) {
                        this.dynamicParents[routeName] = from.name;
                    }
                }
            }

            let currentName = routeName;
            const crumbs: any[] = [];

            // Safety counter to prevent infinite loops in malformed trees
            let depth = 0;
            const maxDepth = 10;

            // Traverse up
            while (currentName && depth < maxDepth) {
                depth++;

                // Determine Title
                let title = customTitles[currentName];
                let url = currentName;

                // Try finding in Menu
                const menuItem = this.Menu.find((x: any) => x.Url === currentName);
                if (menuItem) {
                    title = title || menuItem.Title;
                }
                title = title || currentName;

                crumbs.unshift({ title: title, url: url });

                // Determine Parent
                // Priority: Dynamic -> Static Custom -> Menu Hierarchy
                let parentName = this.dynamicParents[currentName] || customParents[currentName];

                if (parentName) {
                    currentName = parentName;
                } else {
                    // Try to fall back to Menu hierarchy if we are stuck
                    if (menuItem && menuItem.MenuID) {
                        // Find parent in Menu
                        const parentItem = this.Menu.find((x: any) => x.ID == menuItem.MenuID);
                        if (parentItem) {
                            currentName = parentItem.Url || '';
                        } else {
                            // Fallback for root items
                            currentName = '';
                        }
                    } else {
                        // No parent found
                        currentName = '';
                    }
                }

                // Stop if we hit the same node (cycle protection)
                if (crumbs.length > 1 && crumbs[0].url === crumbs[1].url) break;
            }

            // Disable link for the last breadcrumb (current page)
            if (crumbs.length > 0) {
                crumbs[crumbs.length - 1].url = null;
            }

            this.breadcrumb = crumbs;

            if (crumbs.length > 0) {
                this.TabTitle = crumbs[crumbs.length - 1].title;
            }
        },
        markAsSeen() {
            // suprascris din composable la mounted
        }
    },
    mounted() {
        this.GetUser();
        this.loadCompaniesFromStorage();

        if (!this.companies.length) {
            CompanyServices.getAccessibleCompanies()
                .then((resp) => {
                    this.companies = (resp.data as Array<{ ID: string; Name: string }>)
                        .map(c => ({ ID: String(c.ID), Name: c.Name }));
                    localStorage.setItem('ERA_Companies', JSON.stringify(this.companies));


                    if (!this.currentCompanyId && this.companies.length) {
                        const first = this.companies[0];
                        localStorage.setItem('ERA_Company', JSON.stringify(first));
                        this.currentCompanyId = first.ID;
                    }
                }).catch(e => console.error('Nu pot încărca companiile:', e));
        }

        CompanyServices.getMenus()
            .then((response1: any) => {
                response1.data.forEach((x: any) => this.Menu.push(JSON.parse(x.MeniuConfig)));
                this.updateBreadcrumbs(this.$route);
            });

        this.loadModuleAccess();

        // Breadcrumb pentru dashboard-ul de pe pagina de start (HomeDashboard îl anunță).
        window.addEventListener('era-home-breadcrumb', this.onHomeBreadcrumb as any);

        const { changelog, newUpdates, hasNewUpdates, markAsSeen } = useChangelog();
        this.changelog = changelog;
        this.newUpdates = newUpdates;
        this.markAsSeen = () => {
            markAsSeen();
            this.showChangelog = false; // închide dialogul
        };

        // Doar ultima versiune
        this.latestUpdate = this.changelog.length ? [this.changelog[0]] : [];

        if (hasNewUpdates.value) this.showChangelog = true;
    },
    watch: {
        $route(to) {
            this.updateBreadcrumbs(to);
        }
    },
    computed: {
        impersonatedBy(): string | null {
            return JwtServices.GetImpersonatedBy();
        },
        currentUsername(): string {
            try { return JwtServices.GetUsername(); } catch { return ''; }
        },
        changelogGrouped(): Array<{ day: string; entries: any[] }> {
            const newSet = new Set((this.newUpdates as any[] || []).map((e: any) => e.version));
            const groups: Record<string, any[]> = {};
            const order: string[] = [];
            (this.changelog as any[] || []).forEach((e: any) => {
                const d = new Date(e.date);
                const day = isNaN(d.getTime())
                    ? '—'
                    : d.toLocaleDateString('ro-RO', { day: '2-digit', month: 'long', year: 'numeric' });
                if (!groups[day]) { groups[day] = []; order.push(day); }
                groups[day].push({ ...e, isNew: newSet.has(e.version) });
            });
            return order.map(day => ({ day, entries: groups[day] }));
        },
        currentCompanyName(): string {
            const current = this.companies.find(c => c.ID === this.currentCompanyId)
            return current?.Name ?? '—'
        },
        filteredCompanies(): Array<{ ID: string; Name: string }> {
            const q = (this.companySearch || '').trim().toLowerCase()
            if (!q) return this.companies
            return this.companies.filter(c => (c.Name || '').toLowerCase().includes(q))
        },
        otherCompanies(): Array<{ ID: string; Name: string }> {
            return this.filteredCompanies.filter(c => c.ID !== this.currentCompanyId)
        },
        isSuperAdminUser(): boolean {
            return JwtServices.isSuperAdmin()
        },
        // Catalogul de module (nume normalizate) definite in compania curenta,
        // venit din DB (AUTH_DrepturiModule).
        moduleCatalogSet(): Set<string> {
            return new Set((this.moduleCatalog as string[] || []).map(normalizeModuleToken));
        },
        // Modulele (nume normalizate) la care userul are cel putin un meniu,
        // venite din DB.
        moduleAccessibleSet(): Set<string> {
            return new Set((this.moduleAccessible as string[] || []).map(normalizeModuleToken));
        },
        userInitials(): string {
            const n = (this.Username || '').trim()
            if (!n) return '?'
            const parts = n.split(/[\s._-]+/).filter(Boolean)
            const a = parts[0]?.[0] || ''
            const b = parts.length > 1 ? parts[parts.length - 1][0] : (parts[0]?.[1] || '')
            return (a + b).toUpperCase()
        },
        isFullScreenRoute(): boolean {
            return this.$route.path.startsWith('/documente') ||
                   this.$route.path.startsWith('/personal') ||
                   this.$route.path.startsWith('/comenzi') ||
                   this.$route.path.startsWith('/medical') ||
                   this.$route.path.startsWith('/produse') ||
                   this.$route.path.startsWith('/clase') ||
                   this.$route.path.startsWith('/stocuri')
        },
    },

});
</script>
<style scoped>
.imp-pill {
    position: fixed; bottom: 20px; right: 20px; z-index: 3000;
    display: flex; align-items: center; gap: 10px; padding: 8px 10px 8px 12px;
    background: #1e293b; color: #fff; border-radius: 999px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.28); border: 1px solid rgba(255,255,255,0.08);
}
.imp-pill-ico {
    width: 30px; height: 30px; border-radius: 50%; flex-shrink: 0;
    display: flex; align-items: center; justify-content: center;
    background: linear-gradient(135deg, #ff2c21, #ff6a4a);
}
.imp-pill-txt { display: flex; flex-direction: column; line-height: 1.1; }
.imp-pill-lbl { font-size: 10px; text-transform: uppercase; letter-spacing: 0.5px; color: #94a3b8; }
.imp-pill-user { font-size: 13px; font-weight: 700; }
.imp-pill-exit {
    display: inline-flex; align-items: center; gap: 5px; cursor: pointer; margin-left: 4px;
    background: rgba(255,255,255,0.12); border: 1px solid rgba(255,255,255,0.2);
    color: #fff; border-radius: 999px; padding: 5px 12px; font-weight: 700; font-size: 12px;
}
.imp-pill-exit:hover { background: #ff2c21; border-color: #ff2c21; }

/* ========== COMPACT TOP BAR ========== */
.premium-topbar {
    background: #ff5722 !important;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

.menu-btn {
    color: white !important;
}

/* ========== BRANDING ========== */
.app-branding {
    text-decoration: none;
    margin-left: 0.5rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.05rem;
}

.brand-mark {
    display: flex;
    align-items: baseline;
    gap: 0.4rem;
}

.brand-text {
    font-size: 1.25rem;
    font-weight: 800;
    letter-spacing: 0.05rem;
    background: linear-gradient(90deg, #fff 0%, #ffe08a 20%, #ff6a4a 40%, #7ad1ff 60%, #fff 80%, #ffe08a 100%);
    background-size: 300% 100%;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
    animation: brandGradientShift 6s linear infinite, brandGlowPulse 2.4s ease-in-out infinite;
}

@keyframes brandGradientShift {
    0% { background-position: 0% 50%; }
    100% { background-position: 300% 50%; }
}

@keyframes brandGlowPulse {
    0%, 100% { filter: drop-shadow(0 0 3px rgba(255, 255, 255, 0.25)); }
    50% { filter: drop-shadow(0 0 9px rgba(255, 255, 255, 0.6)); }
}

.brand-badge {
    font-size: 0.625rem;
    font-weight: 600;
    color: white;
    background: rgba(255, 255, 255, 0.2);
    padding: 0.125rem 0.375rem;
    border-radius: 3px;
    text-transform: uppercase;
    letter-spacing: 0.05rem;
}

.brand-powered {
    font-size: 0.55rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.65);
    letter-spacing: 0.02rem;
    white-space: nowrap;
}

.brand-powered strong {
    color: rgba(255, 255, 255, 0.9);
    font-weight: 700;
}

/* ========== COMPANY SELECTOR ========== */
.company-selector {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-left: 1rem;
    padding: 5px 10px 5px 6px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 30px;
    background: rgba(255, 255, 255, 0.08);
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s;
}

.company-selector:hover {
    background: rgba(255, 255, 255, 0.16);
    border-color: rgba(255, 255, 255, 0.35);
}

.cs-avatar {
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    color: #ff2c21;
    font-size: 12px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: .3px;
}

.cs-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.1;
    min-width: 0;
}

.cs-eyebrow {
    font-size: 9px;
    font-weight: 700;
    letter-spacing: .6px;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.6);
}

.cs-name {
    max-width: 190px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 13px;
    font-weight: 600;
    color: #fff;
}

.cs-chevron { color: rgba(255, 255, 255, 0.7); }

/* ========== COMPANY DROPDOWN ========== */
.company-dropdown {
    border-radius: 14px !important;
    overflow: hidden;
    min-width: 320px;
    max-width: 420px;
}

.cd-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 16px;
    border-bottom: 1px solid #eef1f6;
}

.cd-title {
    font-size: 13px;
    font-weight: 700;
    color: #1e293b;
}

.cd-count {
    font-size: 11px;
    font-weight: 700;
    color: #64748b;
    background: #f1f5f9;
    padding: 1px 9px;
    border-radius: 20px;
}

.company-search {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 12px 12px 0;
    padding: 8px 12px;
    background: #f1f5f9;
    border-radius: 10px;
}

.cs-search-ico { color: #94a3b8; }

.company-search input {
    border: none;
    outline: none;
    background: transparent;
    width: 100%;
    font-size: 13px;
    color: #334155;
}

.company-list {
    padding: 6px;
    max-height: 360px;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.company-list-item {
    display: flex;
    align-items: center;
    gap: 11px;
    width: 100%;
    text-align: left;
    border: none;
    background: transparent;
    border-radius: 10px;
    padding: 8px 10px;
    cursor: pointer;
    transition: background 0.15s, transform 0.15s, box-shadow 0.15s;
}

.company-list-item:hover {
    background: rgba(255, 44, 33, 0.06);
}

.company-list-item.active {
    background: rgba(255, 44, 33, 0.05);
}

.company-avatar {
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    border-radius: 9px;
    background: #eef1f6;
    color: #64748b;
    font-size: 12px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.15s;
}

.company-list-item:hover .company-avatar { transform: scale(1.05); }

.company-avatar.ring {
    box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #ff2c21;
}

.company-name {
    flex: 1;
    min-width: 0;
    font-weight: 500;
    font-size: 13.5px;
    color: #1e293b;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.company-check {
    flex-shrink: 0;
    color: #ff2c21;
}

.company-empty {
    text-align: center;
    color: #94a3b8;
    font-size: 13px;
    padding: 18px 0;
}

/* ========== USER SECTION ========== */
.user-section {
    display: flex;
    align-items: center;
    gap: 9px;
    padding: 5px 8px 5px 5px;
    border: 1px solid rgba(255, 255, 255, 0.18);
    border-radius: 30px;
    background: rgba(255, 255, 255, 0.08);
    cursor: pointer;
    transition: background 0.2s, border-color 0.2s;
    margin-left: 1rem;
}

.user-section:hover {
    background: rgba(255, 255, 255, 0.16);
    border-color: rgba(255, 255, 255, 0.35);
}

.us-avatar {
    flex-shrink: 0;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    color: #ff2c21;
    font-size: 12px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
}

.user-name {
    color: white;
    font-weight: 600;
    font-size: 13px;
}

.us-chevron { color: rgba(255, 255, 255, 0.7); }

/* ===== USER MENU (dropdown) ===== */
.user-menu {
    border-radius: 14px !important;
    overflow: hidden;
    min-width: 260px;
}

.um-head {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px;
    background: linear-gradient(120deg, #ff2c21, #ff6a4a);
    color: #fff;
}

.um-avatar {
    flex-shrink: 0;
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.9);
    color: #ff2c21;
    font-size: 15px;
    font-weight: 800;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.um-info { display: flex; flex-direction: column; min-width: 0; }
.um-name { font-size: 14px; font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.um-role { font-size: 11px; font-weight: 600; color: rgba(255, 255, 255, 0.8); }

.um-list { padding: 6px; display: flex; flex-direction: column; gap: 2px; }

.um-item {
    display: flex;
    align-items: center;
    gap: 11px;
    width: 100%;
    text-align: left;
    border: none;
    background: transparent;
    border-radius: 10px;
    padding: 10px 12px;
    cursor: pointer;
    font-size: 13.5px;
    font-weight: 500;
    color: #334155;
    transition: background 0.15s;
}

.um-item:hover { background: rgba(255, 44, 33, 0.06); }
.um-item .um-ico { color: #64748b; }
.um-item .um-arrow { margin-left: auto; color: #ff2c21; }
.um-item.danger { color: #dc2626; }
.um-item.danger .um-ico { color: #dc2626; }
.um-item.danger:hover { background: rgba(220, 38, 38, 0.07); }

/* ========== VERSION BADGE ========== */
.version-badge {
    color: white !important;
    cursor: pointer;
    transition: background 0.2s;
    margin-left: 0.75rem;
}

.version-badge:hover {
    background: rgba(255, 255, 255, 0.1) !important;
}

/* ========== PREMIUM DRAWER ========== */
.premium-drawer {
    background: linear-gradient(180deg, #ff5722 0%, #e64a19 100%) !important;
    box-shadow: 2px 0 16px rgba(0, 0, 0, 0.2) !important;
}



/* ========== DRAWER MENU - DARK SIDEBAR ========== */
.drawer-menu-list {
    padding: 0.5rem 0.5rem;
    max-height: calc(100vh - 140px);
    overflow-y: auto;
}

.drawer-menu-list::-webkit-scrollbar {
    width: 5px;
}

.drawer-menu-list::-webkit-scrollbar-track {
    background: transparent;
}

.drawer-menu-list::-webkit-scrollbar-thumb {
    background-color: rgba(255, 255, 255, 0.1);
    border-radius: 4px;
}

.drawer-menu-list::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 255, 255, 0.2);
}

/* ---- NIVEL 1 ---- */
.menu-group-item {
    margin: 1px 0;
    padding-bottom: 4px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

.menu-parent-item {
    background: transparent !important;
    border-radius: 8px !important;
    margin: 0 6px !important;
    min-height: 50px !important;
    height: auto !important;
    transition: background 0.15s ease;
}

.menu-parent-item:hover {
    background: rgba(0, 0, 0, 0.12) !important;
}

.menu-parent-item :deep(.v-list-item-title) {
    font-size: 1rem !important;
    font-weight: 700 !important;
    color: #ffffff !important;
    letter-spacing: 0.01em;
}

.menu-parent-item :deep(.v-icon) {
    color: rgba(255, 255, 255, 0.95) !important;
}

/* N1 fără copii */
.menu-single-item {
    background: transparent !important;
    border-radius: 8px !important;
    margin: 2px 6px !important;
    min-height: 50px !important;
    height: auto !important;
    transition: background 0.15s ease;
}

.menu-single-item:hover {
    background: rgba(0, 0, 0, 0.12) !important;
}

.menu-single-item :deep(.v-list-item-title) {
    font-size: 1rem !important;
    font-weight: 700 !important;
    color: #ffffff !important;
}

.menu-single-item :deep(.v-icon) {
    color: rgba(255, 255, 255, 0.95) !important;
}

/* Container copii N1 — linie verticală */
.menu-group-item :deep(.v-list-group__items) {
    background: transparent !important;
    border-left: 1px solid rgba(255, 255, 255, 0.35);
    margin: 0 6px 6px 23px;
    padding: 2px 0 4px 0 !important;
}

/* ---- NIVEL 2 ---- */
.menu-child-item {
    background: transparent !important;
    border-radius: 0 6px 6px 0 !important;
    margin: 2px 4px 2px 0 !important;
    padding-left: 18px !important;
    min-height: 42px !important;
    height: auto !important;
    position: relative;
    transition: background 0.15s ease;
}

/* Ramură orizontală L2 */
.menu-child-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 12px;
    height: 1px;
    background: rgba(255, 255, 255, 0.35);
    transform: translateY(-50%);
}

.menu-child-item:hover {
    background: rgba(0, 0, 0, 0.1) !important;
}

.menu-child-item :deep(.v-list-item-title) {
    font-size: 0.97rem !important;
    font-weight: 500 !important;
    color: rgba(255, 255, 255, 0.78) !important;
}

.menu-child-item :deep(.v-icon) {
    color: rgba(255, 255, 255, 0.6) !important;
}

/* Container copii N2 — linie verticală */
.menu-subgroup-item :deep(.v-list-group__items) {
    background: transparent !important;
    border-left: 1px solid rgba(255, 255, 255, 0.2);
    margin: 0 4px 4px 13px;
    padding: 1px 0 3px 0 !important;
}

/* ---- NIVEL 3 ---- */
.menu-grandchild-item {
    background: transparent !important;
    border-radius: 0 5px 5px 0 !important;
    margin: 1px 4px 1px 0 !important;
    padding-left: 16px !important;
    min-height: 38px !important;
    height: auto !important;
    position: relative;
    transition: all 0.15s ease;
}

/* Ramură orizontală L3 */
.menu-grandchild-item::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 10px;
    height: 1px;
    background: rgba(255, 255, 255, 0.2);
    transform: translateY(-50%);
}

.menu-grandchild-item:hover {
    background: rgba(0, 0, 0, 0.1) !important;
}

.menu-grandchild-item :deep(.v-list-item-title) {
    font-size: 0.925rem !important;
    font-weight: 600 !important;
    color: rgba(255, 255, 255, 0.55) !important;
    transition: color 0.15s ease;
}

.menu-grandchild-item:hover :deep(.v-list-item-title) {
    color: rgba(255, 255, 255, 0.95) !important;
}

.menu-grandchild-item :deep(.v-list-item-title)::before {
    content: '• ';
    opacity: 0.6;
    transition: opacity 0.15s ease;
}

.menu-grandchild-item:hover :deep(.v-list-item-title)::before {
    opacity: 1;
}

/* ---- Stare activă ---- */
:deep(.v-list-item--active) {
    background: rgba(0, 0, 0, 0.18) !important;
    border-left: 3px solid rgba(255, 255, 255, 0.9) !important;
    border-radius: 0 6px 6px 0 !important;
}

:deep(.v-list-item--active .v-list-item-title) {
    color: #ffffff !important;
    font-weight: 700 !important;
}

:deep(.v-list-item--active .v-icon) {
    color: #ffffff !important;
}

:deep(.v-list-item .v-icon) {
    opacity: 1;
}

/* Chevron */
.menu-parent-item :deep(.v-list-item__append .v-icon) {
    color: rgba(255, 255, 255, 0.6) !important;
}

.menu-child-item :deep(.v-list-item__append .v-icon) {
    color: rgba(255, 255, 255, 0.4) !important;
}

/* ========== DRAWER FOOTER ========== */
.drawer-footer-section {
    padding: 0.75rem;
    background: rgba(0, 0, 0, 0.25);
    border-top: 1px solid rgba(255, 255, 255, 0.06);
}

.footer-divider {
    display: none;
}

.logout-item {
    border-radius: 8px;
    transition: background 0.15s ease;
}

.logout-item :deep(.v-list-item-title) {
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 0.875rem !important;
}

.logout-item :deep(.v-icon) {
    color: rgba(255, 255, 255, 0.7) !important;
}

.logout-item:hover {
    background: rgba(0, 0, 0, 0.15) !important;
    transform: none !important;
}

.logout-item:hover :deep(.v-list-item-title),
.logout-item:hover :deep(.v-icon) {
    color: #ffffff !important;
}

/* ========== MAIN CONTENT ========== */
:deep(.v-main) {
    background: linear-gradient(135deg, #fafafa 0%, #f0f0f0 100%);
    height: 100vh;
    overflow: hidden;
}

.main-content-area {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.content-container {
    height: 100%;
    padding: 1.5rem !important;
    display: flex;
    flex-direction: column;
}

.content-card {
    border-radius: 20px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.08) !important;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}

/* Fixed Header Section */
.card-header-fixed {
    flex-shrink: 0;
    background: linear-gradient(135deg, #ffffff 0%, #fafafa 100%);
    border-bottom: 1px solid #e0e0e0;
}

.card-title-section {
    display: flex;
    align-items: center;
    padding: 1.5rem 2rem !important;
    font-weight: 700 !important;
    color: #333 !important;
    font-size: 1.5rem !important;
}

.breadcrumb-section {
    padding: 1rem 2rem 1rem 2rem;
    background: #fafafa;
}

.breadcrumb-custom {
    padding: 0 !important;
}

.breadcrumb-custom :deep(.v-breadcrumbs-item) {
    font-size: 0.875rem;
    font-weight: 500;
    transition: color 0.2s;
}

.breadcrumb-custom :deep(.v-breadcrumbs-item--link) {
    cursor: pointer;
}

.breadcrumb-custom :deep(.v-breadcrumbs-item:hover) {
    color: #ff5722 !important;
}

.header-divider {
    opacity: 0.2;
}

/* Scrollable Content Section */
.card-content-scrollable {
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
}

.full-screen-content {
    overflow: hidden !important;
    display: flex;
    flex-direction: column;
}

.router-content {
    padding: 2rem;
    min-height: 100%;
}

.router-content-full {
    padding: 0 !important;
    min-height: unset !important;
    flex: 1;
    min-height: 0 !important;
    overflow: hidden;
    display: flex;
    flex-direction: column;
}

/* Custom Scrollbar for Content */
.card-content-scrollable::-webkit-scrollbar {
    width: 8px;
}

.card-content-scrollable::-webkit-scrollbar-track {
    background: #f5f5f5;
}

.card-content-scrollable::-webkit-scrollbar-thumb {
    background-color: rgba(255, 87, 34, 0.3);
    border-radius: 4px;
    transition: background-color 0.2s;
}

.card-content-scrollable::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 87, 34, 0.5);
}

/* ========== BREADCRUMBS (Legacy) ========== */

/* ========== CHIPS ========== */
:deep(.v-chip) {
    font-weight: 600;
    transition: all 0.3s ease;
    border-radius: 8px;
}

:deep(.v-chip:hover) {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

/* ========== DIALOGS ========== */
:deep(.v-dialog .v-card) {
    border-radius: 24px !important;
    overflow: hidden;
    box-shadow: 0 24px 64px rgba(0, 0, 0, 0.2) !important;
}

:deep(.v-dialog .v-card-title) {
    background: linear-gradient(135deg, #fff3e0 0%, #ffe0d5 100%);
    color: #ff5722 !important;
    font-weight: 700 !important;
    border-bottom: 1px solid #ffe0d5;
    padding: 1.5rem 2rem !important;
}

:deep(.v-dialog .v-card-text) {
    padding: 2rem !important;
}

:deep(.v-dialog .v-card-actions) {
    padding: 1.25rem 2rem !important;
    border-top: 1px solid #f0f0f0;
    background: #fafafa;
}

:deep(.v-dialog .v-btn) {
    text-transform: none !important;
    font-weight: 600 !important;
    border-radius: 10px !important;
    padding: 0.75rem 2rem !important;
    transition: all 0.3s ease;
}

:deep(.v-dialog .v-btn:hover) {
    transform: translateY(-3px);
    box-shadow: 0 6px 20px rgba(255, 87, 34, 0.3);
}

/* ========== TIMELINE ========== */
:deep(.v-timeline) {
    padding-top: 0;
}

:deep(.v-timeline-item) {
    padding-bottom: 2rem;
}

:deep(.v-timeline .v-card) {
    border-radius: 14px !important;
    transition: all 0.3s ease;
    border-left: 3px solid #ff5722;
}

:deep(.v-timeline .v-card:hover) {
    transform: translateX(8px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15) !important;
}

/* ========== ANIMATIONS ========== */
@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes pulse {

    0%,
    100% {
        opacity: 1;
    }

    50% {
        opacity: 0.8;
    }
}

/* ========== LIST ENHANCEMENTS ========== */
:deep(.v-list) {
    background: transparent !important;
}

:deep(.v-list-item) {
    transition: all 0.2s ease;
}

/* ========== RESPONSIVE ========== */
@media (max-width: 1280px) {
    .cs-name {
        max-width: 150px;
    }

    .brand-text {
        font-size: 1.5rem;
    }
}

@media (max-width: 960px) {
    .company-selector {
        margin-left: 1rem;
    }

    .cs-name {
        max-width: 120px;
    }

    .user-name {
        display: none;
    }

    .version-badge {
        margin-left: 0.5rem;
    }
}

@media (max-width: 600px) {
    .brand-badge {
        display: none;
    }

    .brand-powered {
        display: none;
    }

    .company-selector {
        margin-left: 0.5rem;
    }

    .version-badge {
        display: none;
    }

    :deep(.v-card-title) {
        font-size: 1.25rem !important;
        padding: 1.25rem 1.5rem !important;
    }

    :deep(.v-breadcrumbs) {
        padding: 0.75rem 1.5rem !important;
    }

    :deep(.v-container) {
        padding: 1rem !important;
    }
}

/* ========== UTILITY CLASSES ========== */
.text-white {
    color: white;
}

.no-underline {
    text-decoration: none;
}

/* ========== PREMIUM EFFECTS ========== */
:deep(.v-btn) {
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

:deep(.v-btn:hover) {
    transform: translateY(-1px);
}

:deep(.v-icon) {
    transition: all 0.2s ease;
}

/* ========== SCROLLBAR GLOBAL ========== */
* {
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 87, 34, 0.3) transparent;
}

*::-webkit-scrollbar {
    width: 8px;
    height: 8px;
}

*::-webkit-scrollbar-track {
    background: transparent;
}

*::-webkit-scrollbar-thumb {
    background-color: rgba(255, 87, 34, 0.3);
    border-radius: 4px;
    transition: background-color 0.2s;
}

*::-webkit-scrollbar-thumb:hover {
    background-color: rgba(255, 87, 34, 0.5);
}

/* ===== Changelog / Istoric versiuni ===== */
.changelog-card {
    border-radius: 14px !important;
    overflow: hidden;
}

.changelog-header {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    background: linear-gradient(90deg, #ff2c21, #ff6a4a);
    color: #ffffff;
    font-size: 15px;
    font-weight: 700;
}

.changelog-body {
    max-height: 60vh;
    overflow-y: auto;
    padding: 16px 18px !important;
    background: #f8f9fc;
}

.cl-day-group {
    margin-bottom: 18px;
}

.cl-day-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #94a3b8;
    margin-bottom: 10px;
}

.cl-timeline {
    position: relative;
    padding-left: 18px;
    border-left: 2px solid #e5e7eb;
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.cl-entry {
    position: relative;
}

.cl-dot {
    position: absolute;
    left: -25px;
    top: 4px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #cbd5e1;
    border: 2px solid #ffffff;
    box-shadow: 0 0 0 2px #e5e7eb;
}

.cl-dot.is-new {
    background: #ff2c21;
    box-shadow: 0 0 0 2px rgba(255, 44, 33, 0.25);
}

.cl-content {
    background: #ffffff;
    border: 1px solid #f1f5f9;
    border-radius: 10px;
    padding: 10px 14px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.cl-entry-head {
    display: flex;
    align-items: center;
    gap: 8px;
}

.cl-version {
    font-size: 13px;
    font-weight: 700;
    color: #1e293b;
}

.cl-new-badge {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.5px;
    color: #ffffff;
    background: #ff2c21;
    padding: 1px 8px;
    border-radius: 20px;
}

.cl-time {
    margin-left: auto;
    font-size: 11px;
    color: #94a3b8;
}

.cl-desc {
    margin-top: 6px;
    font-size: 13px;
    color: #334155;
    line-height: 1.4;
}

.cl-modules {
    margin-top: 8px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.cl-mod-chip {
    font-size: 11px;
    font-weight: 600;
    color: #475569;
    background: #f1f5f9;
    padding: 2px 10px;
    border-radius: 20px;
}

.cl-empty {
    text-align: center;
    color: #94a3b8;
    font-size: 13px;
    padding: 30px 0;
}

/* ===== "Ce e nou" ===== */
.whatsnew-body {
    padding: 16px 18px !important;
}

.wn-desc {
    font-size: 13px;
    color: #334155;
    line-height: 1.5;
    margin-bottom: 12px;
}

.wn-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.wn-group {
    background: #f8f9fc;
    border: 1px solid #f1f5f9;
    border-radius: 10px;
    overflow: hidden;
}

.wn-ghead {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 7px 12px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #ff2c21;
    background: rgba(255, 44, 33, 0.06);
    border-bottom: 1px solid #f1f5f9;
}

.wn-ghead .dotm {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #ff2c21;
}

.wn-ghead .cnt {
    margin-left: auto;
    color: #94a3b8;
    font-weight: 600;
}

.wn-bullets {
    list-style: none;
    margin: 0;
    padding: 8px 14px 10px;
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.wn-bullets li {
    position: relative;
    padding-left: 14px;
    font-size: 13px;
    color: #334155;
    line-height: 1.45;
}

.wn-bullets li::before {
    content: "";
    position: absolute;
    left: 0;
    top: 8px;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #ff6a4a;
}

.wn-empty {
    font-size: 13px;
    color: #94a3b8;
}

/* istoric — grupare pe module in interiorul versiunii */
.cl-grouped {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.clg-mod {
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #ff2c21;
}

.clg ul {
    list-style: none;
    margin: 4px 0 0;
    padding: 0;
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.clg li {
    position: relative;
    padding-left: 13px;
    font-size: 12.5px;
    color: #334155;
    line-height: 1.4;
}

.clg li::before {
    content: "";
    position: absolute;
    left: 0;
    top: 7px;
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: #ff6a4a;
}
</style>
